import http from "./http-common";
import VehiclesModel, { VehicleViewModel } from "../models/vehicles.model";
import {AxiosResponse} from "axios";

export const saveVehicle = (vehicle: VehicleViewModel) => {
    const vehiclePayload = {
        name: vehicle.name,
        description: vehicle.description,
        mechanism_action: vehicle.mechanism_action,
        PH: vehicle.PH,
        incompatibility: vehicle.incompatibility,
        minimum: Number(vehicle.minimum),
        maximum: Number(vehicle.maximum),
        source: vehicle.source,
    };

    if (vehicle.id != null) {
        return http.put(`/vehicles/${vehicle.id}`, vehiclePayload)
    }

    return http.post('/vehicles', vehiclePayload)
}

export const getVehicles = () => http.get(`/vehicles`)

export const enableVehicle = (vehicleId: string) => http.put(`/vehicles/${vehicleId}/enable`)

export const disableVehicle = (vehicleId: string) => http.put(`/vehicles/${vehicleId}/disable`)

export type VehiclesWithFilterNPaginationResponse = {
    "id": number,
    "name": string,
    "description": string,
    "mechanism_action": string,
    "PH": string,
    "incompatibility": string,
    "minimum": number,
    "maximum": number,
    "source": string,
    "favorite": number,
    "enabled": number,
}
